import { buildLeadProviderChatMenuAccounts } from '@pages/Admin/CRM/utils/leadProviderChatMenu'

export type LeadProviderChatMenuAccounts = ReturnType<
  typeof buildLeadProviderChatMenuAccounts
>

export const sumAccessibleMenuUnread = (
  accounts: LeadProviderChatMenuAccounts,
): number =>
  accounts.reduce((sum, account) => {
    if (account.isAccessible === false) return sum

    if (account.channels) {
      const fromChannels = account.channels.reduce((channelSum, channel) => {
        if (channel.isAccessible === false) return channelSum
        const channelCount = Number(channel.unread_count ?? 0)
        if (Number.isFinite(channelCount) && channelCount > 0) {
          return channelSum + Math.floor(channelCount)
        }
        return (
          channelSum +
          channel.dialogs.reduce((dialogSum, dialog) => {
            if (dialog.isAccessible === false) return dialogSum
            const count = Number(dialog.unread_count ?? 0)
            return (
              dialogSum +
              (Number.isFinite(count) && count > 0 ? Math.floor(count) : 0)
            )
          }, 0)
        )
      }, 0)
      if (fromChannels > 0) {
        return sum + fromChannels
      }
      const accountCount = Number(account.unread_count ?? 0)
      return (
        sum +
        (Number.isFinite(accountCount) && accountCount > 0
          ? Math.floor(accountCount)
          : 0)
      )
    }

    const count = Number(account.unread_count ?? 0)
    return sum + (Number.isFinite(count) && count > 0 ? Math.floor(count) : 0)
  }, 0)
